/* eslint-disable import/no-extraneous-dependencies */
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@repo/ui";
import { useMemo } from "react";
import eventBus from "store/event-emitter";
import { formatCamelCaseToLabel } from "utils/helper";
import { getField, getValueField } from "./utils";
import { useUser } from "hooks/use-user";
import { isCallCenterAgent } from "pages/tickets/utils";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";

export default function ColumnActionsCell(cellProps = {}) {
  const { dataItem, field, ...otherProps } = cellProps;
  const navigationAttributes = useTableKeyboardNavigation(cellProps.id);
  const middleAlignColumns = ["status"];
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  const cellValue = useMemo(() => {
    return dataItem[field];
  }, [dataItem, field]);
  return (
    <td
      {...otherProps}
      {...navigationAttributes}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: cellProps.columnIndex }}
      aria-selected="false"
      className="k-table-td overflow-visible column-action-trigger-td "
      style={{ padding: 0 }}
    >
      <ContextMenu>
        <ContextMenuTrigger>
          <div className="flex items-center h-full column-action-trigger">
            <p
              title={cellValue}
              className={`w-full ${
                middleAlignColumns.includes(field) ||
                field.includes("time") ||
                field.includes(" at")
                  ? "text-center"
                  : ""
              }`}
            >
              {cellValue}
            </p>
          </div>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <ContextMenuItem
            onClick={() => {
              eventBus.emit("applyActions", {
                type: "group",
                field,
                value: cellValue,
              });
            }}
          >
            Group By
          </ContextMenuItem>
          <ContextMenuItem
            onClick={() => {
              const value = dataItem[getValueField(field, !isCCA)];
              const _field = getField(field, !isCCA);
              const label = formatCamelCaseToLabel(getField(field, !isCCA));
              eventBus.emit("applyActions", {
                type: "filter",
                name: cellValue,
                field: _field,
                value,
                label,
              });
            }}
          >
            Filter Out
          </ContextMenuItem>
          <ContextMenuItem
            onClick={() => {
              const value = dataItem[getValueField(field, !isCCA)];
              const _field = getField(field, !isCCA);
              const label = formatCamelCaseToLabel(getField(field, !isCCA));
              eventBus.emit("applyActions", {
                type: "matching",
                name: cellValue,
                field: _field,
                value,
                label,
              });
            }}
          >
            Matching
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    </td>
  );
}
